import { computed } from 'vue'
import { filters, numberAdd, getValueByPath } from '../../../utils/index'

/***
 * total是通过接口获取表格数据，接口返回的总计
 */
export function useFooter(props, tableData, tableConfig, total) {
  //是否显示合计栏,,这里初始值设置为true用于解决表格表格高度自动时存在的问题
  const showFooter = computed(() => tableConfig.value?.total ?? true)

  //计算合计-包含树状结构
  const totalColumnFn = (item, columnParam) => {
    const parameter = columnParam?.parameter
    let resData =
      parameter?.parentHide && !item._PARENT && item.children?.length > 0
        ? 0
        : getValueByPath(item, columnParam?.property)
    if (item.children?.length > 0 && !parameter?.childHide) {
      resData = item.children.reduce((pre, cur) => {
        return numberAdd(pre, totalColumnFn(cur, columnParam))
      }, resData)
    }
    return resData
  }
  return {
    showFooter,
    //计算合计栏
    footerMethod({ columns, data }) {
      const all = []
      const nowPage = columns.map((column, index) => {
        if (props.showPagination || total.value) {
          if (index === 0) {
            all.push('总计')
          } else if (column.params?.total) {
            const allVal = total.value
              ? total.value?.[
                  column.params?.footer || `total_${column.params?.property.replace(/#|\./g, '_')}`
                ]
              : tableData.value.reduce(
                  (acc, cur) => numberAdd(acc, getValueByPath(cur, column.params?.property)),
                  0
                )
            const parameter = column.params?.parameter
            all.push(filters(allVal, parameter?.type, parameter?.format, parameter?.symbol))
          } else {
            all.push('')
          }
        }

        if (props.isPageTotal && index === 0) {
          return '当页合计'
        } else if (props.isPageTotal && column.params?.total) {
          const sumVal = data.reduce((acc, cur) => {
            return numberAdd(acc, totalColumnFn(cur, column.params))
          }, 0)
          const parameter = column.params?.parameter
          return filters(sumVal, parameter?.type, parameter?.format, parameter?.symbol)
        } else {
          return ''
        }
      })

      const res = props.isPageTotal ? [nowPage] : []
      all.length > 0 && res.push(all)
      return res
    },
  }
}
